import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';
import { createDsbcApiUrl } from '../dsbc/createDsbcApiUrl';

/* 完成任务 */
type GetkickOffTimeReq = {
  compId: string; //活动编号
  inShow: Boolean; //编码
};
export interface RaceInfo {
  compId: string;
  signFlag: boolean;
  fullName: string;
  raceStartTime: string;
  raceEndTime: string;
  signStartTime: string;
  signEndTime: string;
  /**@enum {'0' | '1' | '2'}  参赛状态，0-已结束，1-进行中，2-未开始 */
  raceFlag: '0' | '1' | '2';
  raceId: string;
  period?: string;
  showFlag?: boolean;
}
interface GetkickOffTimeRes {
  Data: {
    raceList: RaceInfo[];
  };
}
/*完成任务*/
export async function getkickOffTime(request: GetkickOffTimeReq) {
  const url = await createDsbcApiUrl('/config/getRaceInfo');
  return zqhdApi.fetch<GetkickOffTimeRes>(url, request);
}
